import { apiInstance } from "@core/api/axios/apiInstance";
import { parseSchema } from "@core/model/parseSchema";
import { codesResponseSchema, type CodesResponseType } from "@features/account/model/response/codes.response";

/**
 * 코드값 조회
 * PC방 등록/수정 시 필요한 코드 리스트 API.
 */
export const fetchCodes = async (): Promise<CodesResponseType | null> => {
  const res = await apiInstance.get("/codes");

  return parseSchema<CodesResponseType>({
    schema: codesResponseSchema,
    rawData: res?.data,
  });
};
